import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import { ContextProvider } from "./ContextAPI/ContextAPI";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// root.render(
//   <ContextProvider>
//     <App />
//   </ContextProvider>
// );

const app = (
  <ContextProvider>
    <App />
  </ContextProvider>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered content exists (production build after react-snap) — hydrate it
  hydrateRoot(rootElement, app);
} else {
  // No pre-rendered content (local dev server) — render normally
  createRoot(rootElement).render(app);
}